import LinkInterceptor from "./link-interceptor.js";
import LinkInterceptCallback from "./link-intercept-callback.js";
import EmbeddedContentView from "./embedded-content-view.js";

export default class Router {

  #linkInterceptor;
  #linkInterceptCb
  #contentView;
  #ui;

  // the current page
  page;

  constructor() {
    this.#linkInterceptor = new LinkInterceptor();
    this.#linkInterceptCb = new LinkInterceptCallback(this.#linkInterceptor);
    this.#contentView = new EmbeddedContentView();
  }

  init($container, isModal = false) {
    this.#contentView.init($container, isModal);
    this.#cacheUiElements($container);

    this.#linkInterceptor.init();
    this.#interceptInternalLinks();
    this.#enableLinkCallbacks();
  }

  async load(url, data = {}, http_method = "GET") {
    await this.#contentView.load(url, data, http_method);
  }

  pauseLinkInterceptor() {
    this.#disableLinkCallbacks();
  }

  resumeLinkInterceptor() {
    this.refreshIntercepts();
  }

  #cacheUiElements($container) {
    this.#ui = {
      container: $container
    };
  }

  refreshIntercepts() {
    this.#disableLinkCallbacks();
    this.#interceptInternalLinks();
    this.#enableLinkCallbacks();
  }

  #interceptInternalLinks() {
    const internalOrigin = new URL(window.location.href).origin;

    let hrefs = [];
    this.#ui.container.find("a").filter((index, a) => {
      // Skip external links
      const href = new URL(a.href, internalOrigin);
      if (href.origin != internalOrigin) {
        return false;
      }

      // Skip form-submit links, as these are submitted via a form.
      if ($(a).hasClass("form-submit")) {
        return false;
      }

      // Handle all other links
      return true
    }).each((index, a) => hrefs.push(a.href));

    this.#interceptLinks(hrefs);
  }

  #interceptLinks(hrefs) {
    this.#linkInterceptCb.create("Router navigation",
      (href) => {
        const url = new URL(href, window.location.origin);
        // Ignore links to the same page
        if (url.pathname !== window.location.pathname) {
          // Load the content in the embedded view
          this.load(href);
        }

        // Prevent the default request being sent
        return null;
      }, ...hrefs);
  }

  #enableLinkCallbacks() {
    this.#linkInterceptCb.enable();
  }

  #disableLinkCallbacks() {
    this.#linkInterceptCb.disable();
  }
}